import '@babel/polyfill'

import Vue from 'vue'

// browser
import '@lib/utils/browser.js'

// iview
import './iview.js'
import '@/assets/css/global.scss'

// css
import '@lib/assets/css/reset_pc.css'
import '@/assets/css/function.scss'
import '@/assets/iconFont/iconfont.css'

import './pattern.js' // 正则
import './vueDirective' // 指令相关

// loading
import '@components/loading'
// modal
import abModal from '@components/abModal'
// form
import abForm from '@components/form'
// input
import abInput from '@components/input'
// select
import AbSelect from '@components/select'
// inputNumber
import AbInputNumber from '@components/input-number'
// AbDatePicker
import AbTimePicker from '@components/abTimePicker/index.js'
// abStep
import AbSteps from '@components/steps'

// 日期处理
import '@lib/utils/g.date.js'
import '@lib/utils/dateHelper.js'

// 百度埋点自定义事件
import BDTargetEvent from './BDTargetEvent'
// H5下加载H5全局组件
import { Tips } from '@/module/views/components/h5/vue-popup-plugin'
// 错误监控
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

// 加载requestAnimationFrame
require('@/module/views/home/js/requestAnimationFrame.js')

Vue.use(BDTargetEvent)
Vue.use(abModal)
Vue.use(abForm)
Vue.use(abInput)
Vue.use(AbSelect)
Vue.use(AbInputNumber)
Vue.use(AbTimePicker)
Vue.use(AbSteps)
Vue.use(Tips)

Vue.prototype.$host = process.host

if (process.env.NODE_ENV === 'development') {
  Vue.prototype.$host.CDN = ''
}

if (location.hostname !== 'localhost') {
  Sentry.init({
    dsn: 'https://8a13db8d42fc4745bb46cbf46fe8cd16@sentry.anbankeji.com/7',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    captureUnhandledRejections: false,
    environment: process.host.deployMode
  })
}
